// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { any, boolean } from "@altostra/type-validations/lib/primitives";

export const isRemoteLookupFindResult = objectOf({
  item: any,
});

export const isRemoteLookupSearchResult = objectOf({
  items: arrayOf(any),
  has_next_page: boolean,
});
